import queryString from 'query-string';
import { has, isNil, cloneDeep } from 'lodash';
import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import types from './mutation-types';

export function fetchStoreCards({ dispatch }, filters) {
  const queryParams = queryString.stringify(filters);

  return http.get(`${MINERVA_API_URL}/store-cards?${queryParams}`)
    .then((res) => {
      if (!filters.offset) {
        return dispatch('setStoreCardsInStore', res.data);
      }

      return dispatch('addStoreCardsInStore', res.data);
    })
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching store cards:', err);
      return Promise.reject(err);
    });
}

export function fetchStoreCardDetails({ dispatch }, cardId) {
  return http.get(`${MINERVA_API_URL}/store-cards/${cardId}`)
    .then(res => (
      res.data
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching store card details:', err);
      return Promise.reject(err);
    });
}

export function fetchStoreCardPages({ dispatch }, cardId) {
  return http.get(`${MINERVA_API_URL}/store-cards/${cardId}/pages`)
    .then(res => (
      dispatch('setStoreCardPages', { cardId, pageList: res.data })
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching store card pages:', err);
      return Promise.reject(err);
    });
}

export function fetchPublisherCardPages({ dispatch }, cardId) {
  return http.get(`${MINERVA_API_URL}/cards/${cardId}/pages`)
    .then(res => (
      dispatch('setCustomCardPages', { cardId, pageList: res.data })
    ))
    .then(pageList => (
      dispatch('setPublisherCardPages', { cardId, pageList: cloneDeep(pageList) })
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching publisher card pages:', err);
      return Promise.reject(err);
    });
}

export function setStoreCardsInStore({ commit }, cardList) {
  commit(types.SET_CARDS, cardList);

  return Promise.resolve(cardList);
}

export function addStoreCardsInStore({ commit, getters }, cardList) {
  const filteredCardList = cardList.filter(card => (
    (!isNil(card.store_card_id) && !has(getters.storeCards, card.id)) ||
    (isNil(card.store_card_id) && !has(getters.publisherCards, card.id))
  ));

  commit(types.ADD_CARDS, filteredCardList);

  return Promise.resolve(filteredCardList);
}

export function setSelectedStoreCardId({ commit }, cardId) {
  commit(types.SET_SELECTED, cardId);

  return Promise.resolve();
}

export function setStoreCardPages({ commit }, setInfo) {
  commit(types.SET_CARD_PAGES, setInfo);

  return Promise.resolve(setInfo.pageList);
}

export function setPublisherCardPages({ commit }, setInfo) {
  commit(types.SET_PUB_CARD_PAGES, setInfo);

  return Promise.resolve(setInfo.pageList);
}



// WEBPACK FOOTER //
// ./src/app/store-cards/store/actions.js